import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: 'app-schedule-overlap-dialog',
    template: require('./scheduleOverlapDialog.html')
})
export class ScheduleOverlapDialog {

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
                @Inject(MatDialogRef<ScheduleOverlapDialog>) public dialogRef: MatDialogRef<ScheduleOverlapDialog>) {
    }

    closeThisDialog(value: any) {
        this.dialogRef.close(value)
    }
}
